<template>
  <div class="page-content conmon-top">
    <div class="base-input ovf-hd" style="margin-bottom: 10px;">
      <el-row class="search-title">
        <el-col :span="4" class="search-nav-left">
          <i class="el-icon-search" style="font-weight: bold;"></i>
          <span class="order-list-search-span">筛选查询</span>
        </el-col>
        <el-col :span="20" class="search-nav-right">
          <el-button class="search-open-close" type="text" @click="hide=!hide" v-show="hide"> {{ hide? '收起查询':'展开查询' }}</el-button>
          <el-button class="search-open-close" type="text" @click="hide=!hide" v-show="!hide">{{ hide? '收起查询':'展开查询' }}</el-button>
          <i v-if="hide === true" class="el-icon-arrow-up search-open-close-i" @click="hide=!hide"></i>
          <i v-if="hide === false" class="el-icon-arrow-down search-open-close-i" @click="hide=!hide"></i>
          <el-button class="search-btn-new" type="primary" size="small" @click="searchData">查询</el-button>
        </el-col>
      </el-row>
        <el-collapse-transition>
          <div v-show="hide" class="search-content common-search-formtype">
            <el-form :inline="true" :model="formInlineTmp" class="search-content-item">
              <el-form-item label="公告名称:">
                <el-input v-model="formInlineTmp.title" placeholder="请输入公告名称" clearable></el-input>
              </el-form-item>
              <el-form-item label="开始时间:">
                <el-date-picker style="width:193px;"
                  v-model="formInlineTmp.start_date"
                  type="datetime"
                  class="time-picker"
                  placeholder="开始时间"
                  value-format="yyyy-MM-dd HH:mm:ss">
                </el-date-picker>
              </el-form-item>
              <el-form-item label="结束时间:">
                <el-date-picker style="width:193px;"
                  v-model="formInlineTmp.end_date"
                  type="datetime"
                  class="time-picker"
                  placeholder="结束时间"
                  value-format="yyyy-MM-dd HH:mm:ss">
                </el-date-picker>
              </el-form-item>
            </el-form>
          </div>
        </el-collapse-transition>
    </div>
    <el-row class="search-title common-table-top" style="padding-right:0">
      <el-col :span="4" style="text-align: left;">
        <i class="el-icon-document" style="font-weight: bold;"></i>
        <span class="order-list-search-span">公告列表</span>
      </el-col>
      <el-col :span="20" class="text-align-right">
        <el-button type="primary" @click="addNoticeListAction" class="add-btn" style="float: right;">添加</el-button>
      </el-col>
    </el-row>
    <el-row class="import-data-title table-first-style">
      <el-table
        :data="tableData"
        v-loading="loading"
        class="table">
        <!-- <el-table-column
          label="缩略">
          <template slot-scope="scope">
            <img :src="scope.row.picture" class="table-img">
          </template>
        </el-table-column> -->
        <el-table-column
          prop="grades_list"
          label="公告范围">
        </el-table-column>
        <el-table-column
          prop="title"
          label="公告名称">
        </el-table-column>
        <el-table-column
          label="开始时间"
          width="135">
          <template slot-scope="scope">
            {{scope.row.start.substring(0, 16)}}
          </template>
        </el-table-column>
        <el-table-column
          label="结束时间"
          width="135">
          <template slot-scope="scope">
            {{scope.row.end.substring(0, 16)}}
          </template>
        </el-table-column>
        <el-table-column
          width="80"
          label="状态">
          <template slot-scope="scope">
              <div v-if="scope.row.status === 1" @click="switchChange(scope.row, 0)" class="enable-button">禁用</div>
              <div v-if="scope.row.status === 0" @click="switchChange(scope.row, 1)" class="enable-button">启用</div>
            <!--<el-switch-->
              <!--v-model="scope.row.status"-->
              <!--:active-value="1"-->
              <!--:inactive-value="0"-->
              <!--@click.native="switchChange(scope.row)"-->
              <!--active-text=""-->
              <!--inactive-text="">-->
            <!--</el-switch>-->
          </template>
        </el-table-column>
        <el-table-column label="操作" width="120" style="display: flex;justify-content: center">
          <template slot-scope="scope">
            <div class="op-link" @click="pushToEditNoticePage(scope.row.id)">
              编辑
            </div>
            <div class="op-link" @click="deleteAdviristAction(scope.row.id)">
              删除
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="table-foot">
        <el-pagination
          class="table-foot-pagination"
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-size="limit"
          layout="total, prev, pager, next, jumper"
          :total="totalCount">
        </el-pagination>
      </div>
    </el-row>
  </div>
</template>
<script>
import { getNoticeList, changeNoticeStatus, deleteNotice, getMemberLevelList } from '@/api/customer.js'
export default {
  name: 'importData',
  data () {
    return {
      formInlineTmp: {},
      formInline: {
      },
      loading: true,
      hide: true,
      tableData: [],
      page: 1,
      limit: 10,
      totalCount: 0,
      isSwitchClick: 1,
      memberLevelList: []
    }
  },
  methods: {
    searchData() {
      this.formInline = JSON.parse(JSON.stringify(this.formInlineTmp))
      this.page = 1
      this.getData()
    },
    switchChange(row, status) {
      if (this.isSwitchClick === 1) {
        this.isSwitchClick = 0
        this.$nextTick(() => {
          changeNoticeStatus(row.id, status).then((res) => {
            if (res.data.code === 0) {
              _g.toastMsg('success', res.data.error)
            } else {
              _g.toastMsg('error', res.data.error)
            }
            this.isSwitchClick = 1
            this.getData()
          })
        })
      }
    },
    addNoticeListAction() {
      router.push('/home/add-notice')
    },
    pushToEditNoticePage(Id) {
      router.push({ path: '/home/edit-notice', query: { id: Id } })
    },
    // 处理分页
    handleSizeChange(val) {
      this.limit = val
      this.getData()
    },
    handleCurrentChange(page) {
      this.page = page
      this.getData()
    },
    deleteAdviristAction(itemId) {
      this.$confirm('确认删除该公告?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteNotice(itemId).then((res) => {
          if (res.data.code === 0) {
            _g.toastMsg('success', '删除公告成功')
          } else {
            _g.toastMsg('error', res.data.error)
          }
          this.getData()
        })
      }).catch((error) => {
        console.log(error)
      })
    },
    getData() {
      this.loading = true
      getNoticeList(this.page, this.formInline).then(res => {
        if (res.data.code === 0) {
          let array = res.data.data.list
          this.totalCount = res.data.data.total
          for (let item of array) {
            item.in_grade_list = []
            item.in_grade_list = item.grade_list.split(',')
            item.grades_list = [] // 列表放入空数组存放会员等级名称
          }
          for (let items of array) {
            for (let one of items.in_grade_list) {
              items.grades_list.push(this.memberLevelList[one]) // 取出对应的会员等级名称放入数组 grade_list
            }
            items.grades_list = items.grades_list.toString()
          }
          this.tableData = array
        } else {
          _g.toastMsg('error', res.data.error)
        }
      })
      this.openLoading()
    },
    getMemberLevel() {
      getMemberLevelList(1, {}).then(res => {
        for (let i in res.data.data.list) {
          let item = res.data.data.list[i]
          this.memberLevelList[item.id] = item.level_title
        }
        this.getData()
      })
    },
    // 数据加载时的动画
    openLoading() {
      setTimeout(() => {
        this.loading = false
      }, 500)
    }
  },
  created() {
    this.getMemberLevel()
  },
  components: {
  }
}
</script>

<style scoped>
.sign-manage-title {
  background: #ecf6ff;
  border: 1px solid #E4e4e4;
  height:60px;
  padding:10px;
  line-height: 40px;
  margin-top: 10px;
}
.table-title {
  text-align: left;
}
.dialog-content {
  height: 200px;
}
.content-one span {
  display: inline-block;
  float: left;
  line-height: 20px;
  font-size: 16px;
  margin-top: 10px;
}
.content-one p {
  text-align: left;
}
.enable-button {
    color: #1980FF;
    cursor: pointer;
    font-size: 14px;
}
</style>
